<template>
    <div class="cus">
      <div class="cover"></div>
      <img src="../../../../static/images/mallBg.jpg" alt="">
      <div class="icon"></div>
      <div class="use">
        <div class="wrapper">
          <ul class="use-nav">
            <li>当前余额 : 0元</li>
            <li class="line">|</li>
            <router-link to="" tag="li" class="nav-info">立即充值</router-link>
            <li class="line">|</li>
            <li class="nav-info" @click="userHandle()">{{this.user}}</li>
          </ul>
        </div> 
      </div>
    </div>
</template>

<script>
export default {
  name: 'banner',
  data () {
    return {
      user: '加入会员'
    }
  },
  methods: {
    userHandle: function () {
      if (this.user === '加入会员') {
        this.$router.push("/entry/register")
      }
    }
  },
  created () {
    let user = localStorage.getItem('user') || '加入会员'
    this.user = user
  }
}
</script>
<style scoped>
  .cus {
    position: relative;
    width: 100%;
    text-align: center;
    overflow: hidden;
  }
  .cover {
    background-color: rgba(58, 58, 58, .4);
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  img {
    width: 100%;
    display: block;
    min-height: 280px;
    text-align: center;
  }
  .icon{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 900px;
    height: 280px;
    margin-left: -450px;
    margin-top: -140px;
    background: url("../../../../static/images/mallBgText.png") no-repeat;
    background-size: 100%;
    transition: all .5s;
    z-index: 3;
  }
  .icon:hover{
    transform: scale(1.05);
  }
  .use {
    background-color: rgba(58, 58, 58, .6);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  .wrapper {
    width: 60%;
    margin: 0 auto;
  }
  .use-nav {
    display: flex;
    justify-content: flex-end;
  }
  .use-nav > li{
    font-size: 24px;
    color: #fff;
    line-height: 80px;
    cursor: pointer;
    transition: all .6s ease;
  }
  .nav-info:hover {
    color: #a3f1c6;
  }
  .line {
    margin: -2px 10px;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .icon{
      width: 500px;
      height: 200px;
      margin-left: -250px;
      margin-top: -100px;
    }
    .use-nav > li{
      font-size: 20px;
      line-height: 64px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .icon{
      width: 400px;
      height: 160px;
      margin-left: -200px;
      margin-top: -80px;
    }
    .use-nav > li{
      font-size: 16px;
      line-height: 50px;
    }
  }
  @media screen and (max-width: 767px){
    .icon{
      width: 300px;
      height: 120px;
      margin-left: -150px;
      margin-top: -60px;
    }
    .wrapper {
      width: 100%;
    }
    .use-nav {
      justify-content: center;
    }
    .use-nav > li{
      font-size: 16px;
      line-height: 50px;
    }
  }
  @media (min-width: 768px){

  }
</style>




// WEBPACK FOOTER //
// src/components/mall/common/banner.vue